import { useCurrentShowId } from "hooks";
import useCurrentExhibitorPair from "hooks/useCurrentExhibitorPair";
import useCurrentExhibitorPairId from "hooks/useCurrentExhibitorPairId";
import { useProductPurchaseCount } from "store/product/product-purchase-per-stand.store";

export const useExhibitorProductPurchaseCount = (productId: string) => {
  const showId = useCurrentShowId();
  const exhibitorPairId = useCurrentExhibitorPairId();
  const [exhibitorPair] = useCurrentExhibitorPair({ showId, exhibitorPairId });
  const standId = exhibitorPair?.stand?.id;
  return useProductPurchaseCount(productId, standId);
};
